﻿{
  "community": {
    "name": "Communauté",
    "shortDescription": "Compte unique avec activités gratuites",
    "features": [
      "Rechercher et partager des activités",
      "Stockage d’activités illimité sur le cloud",
      "Accès aux activités haut de gamme"
    ],
    "price": "Libre",
    "termName": "À vie"
  },
  "personal": {
    "name": "Privé",
    "shortDescription": "Compte unique avec activités personnalisées",
    "features": [
      "Créez et éditez des activités en ligne",
      "Comprend une playlist personnelle",
      "Accéder aux activités en déplacement"
    ]
  },
  "professional": {
    "name": "Professionnel",
    "shortDescription": "Compte unique avec plusieurs élèves",
    "features": [
      "Gérer les travaux des élèves",
      "Superviser les progrès des élèves",
      "Collaborer avec les membres de l’équipe."
    ]
  },
  "organization": {
    "name": "Organisation",
    "shortDescription": "Plusieurs comptes avec plusieurs élèves",
    "features": [
      "Gestion de l’instructeur",
      "Rapports au niveau de l'organisation",
      "Paramètres de confidentialité d’entreprise"
    ],
    "price": "Nous contacter",
    "termName": "Durée de 1 à 5 ans"
  },
  "trialLicense": {
    "name": "Boardmaker 7",
    "shortDescription": "Aperçu de l'éditeur de bureau",
    "note": "Essayez <1>$t(common:action.free)</1> pendant 30 jours !",
    "price": "Libre",
    "termName": "Essai de 30 jours",
    "footerNote": "1 installation"
  },
  "boardmakerLicense": {
    "name": "Boardmaker 7",
    "shortDescription": "Éditeur de bureau complet",
    "note": "",
    "termName": "Achat unique",
    "footerNote": "2 installations par utilisateur"
  },
  "licenseRequest": {
    "name": "Boardmaker 7",
    "shortDescription": "Plusieurs licences pour les organisations",
    "note": "",
    "price": "Nous contacter",
    "termName": "Tarification dégressive",
    "footerNote": "2 installations par utilisateur"
  }
}
